import request from '@/services/interceptor.js'

// Statistiche sui preventivi. Tutti gli endpoint accettano il periodo opzionale
// { dal, al } in formato yyyy-MM-dd (estremi inclusi); senza filtro = tutto lo storico.
const get = (url, params) => {
    return request({
        url: '/statistiche/' + url,
        method: 'get',
        params,
        loadingBar: true
    })
};

export const get_kpi = (periodo) => get('kpi', periodo)

export const get_andamento = (periodo, raggruppa) => get('andamento', { ...periodo, raggruppa })

export const get_stagionalita = (periodo) => get('stagionalita', periodo)

export const get_clienti = (periodo, top) => get('clienti', { ...periodo, top })

export const get_fasce_importo = (periodo) => get('fasce-importo', periodo)

export const get_zone = (periodo) => get('zone', periodo)
